import { hasAnyRole, UserRole } from '@myapp/contract'
import { useAuthStore } from '../../features/auth'

const COMPLETED_RESCHEDULE_ROLES: UserRole[] = ['DIRECTOR', 'SUPERUSER', 'MANAGER', ]

export function useUserRoles(): UserRole[] {
  return useAuthStore((s) => s.user?.roles ?? [])
}

export function useCanRescheduleCompleted(): boolean {
  const roles = useUserRoles()
  return hasAnyRole(roles, COMPLETED_RESCHEDULE_ROLES)
}
